<template>
  <div class="page-div">
    <!-- 顶部导航 -->
    <home-header v-if="pgType=='todo'" />

    <!-- 采集须知页面 -->
    <div class="main-div">
      <div class="content-div">
        <div v-if="!errFlag">
          <h2 class="con-title">{{ model.projectName }}</h2>
          <div v-if="expireFlag" style="margin-bottom: 12px">
            <p style="text-align: center;color: red;font-size: 18px;">
              填报起止时间： {{ formatTime(model.beginTime, '00:00:00') }} ~~ {{ formatTime(model.endTime, '23:59:59') }}
            </p>
          </div>
          <div v-if="showNotice" class="con-artc">
            <!-- 阅读须知内容 -->
            <div v-html="model.noticeInfo"></div>
          </div>
          <div class="con-button">
            <p style="padding:12px 0;" v-if="showNotice && noticeTime > 0">
              <span style="color:red;">{{ noticeTime }}</span>s后可操作
            </p>
            <p v-else>
              <a-button type="primary" @click="goFillInfo" v-if="editFlag" style="margin-right:12px;">填报</a-button>
              <a-button @click="goPreInfo">预览</a-button>
            </p>
          </div>
        </div>
        <!-- 页面异常情况展示 -->
        <div v-else>
          <p style="text-align: center;color: red;margin: 150px auto;font-size: 36px;">
            获取采集数据失败，请检查页面URL是否正确或者刷新页面重试
          </p>
        </div>
      </div>
    </div>
    <Foot ref="footer" />
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header'
import Foot from '@/common/components/Foot'
import { mapState } from 'vuex'

export default {
  name: 'CollectNoticeIndex',
  components: {
    HomeHeader,
    Foot
  },
  data () {
    return {
      noticeTime: '', // 须知显示时间
      tipVisible: false, // 倒计时是否显示
      model: {},
      projectId: this.$route.query.pid || null,
      bid: this.$route.query.bid || null,
      pgType: this.$route.query.pt || null,
      editFlag: false, // 是否允许编辑
      errFlag: false, // 是否显示错误页面
      expireFlag: false, // 是否限时有效
      showNotice: true, // 是否显示采集须知
      readFlag: false // 须知是否已阅读
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created () {
    this.getProjectDetail()
  },
  mounted () {
    if (!this.projectId) {
      this.errFlag = true
    }
  },
  methods: {
    formatTime(timeStr, specialTime) {
      if (!timeStr) {
        return ''
      }
      // 如果包含特殊时间点，则只显示日期部分
      if (timeStr.includes(specialTime)) {
        return timeStr.split(' ')[0] // 取日期部分
      }
      return timeStr
    },

    // 查询项目信息
    getProjectInfo () {
      const that = this
      if (!that.projectId) {
        return
      }
      const url = '/biz/infocollect/getCollectProject?pid=' + that.projectId
      that.axios.get(url).then((res) => {
        if (res.success) {
          that.errFlag = false
          const resData = res.result
          that.model = resData
          // 阅读须知阅读状态
          if (resData.readFlag === 1) {
            that.readFlag = true
          } else {
            that.readFlag = false
          }
          // 判断是否展示阅读须知
          if (resData.noticeVisible) {
            that.showNotice = true
            that.noticeTime = resData.readSecond
          } else {
            that.showNotice = false
            that.noticeTime = 0
          }
          // 项目限时有效
          if (resData.isExpired === 0) {
            that.expireFlag = true
            // 判断当前日期
            let curDate = new Date()
            if (curDate > Date.parse(resData.beginTime) && curDate < Date.parse(resData.endTime)) {
              that.editFlag = true
            } else {
              that.noticeTime = 0
              that.editFlag = false
            }
          } else {
            that.expireFlag = false
            that.editFlag = true
          }

          // 用户已经阅读过阅读须知
          if (that.readFlag) {
            that.noticeTime = 0
          }
          resData.editFlag = that.editFlag
          that.common.setStorage('projectInfo', resData)
          const itemList = resData.itemList || []
          if (itemList.length > 0) {
            itemList.forEach(item => {
              let tmpList = []
              let tmpImgList = []
              if (item.visibles) {
                let visibleData = JSON.parse(item.visibles)
                for (let tmp of Object.entries(visibleData)) {
                  if (tmp[1].show) {
                    let tmpData = {
                      index: tmp[0],
                      label: tmp[1].label,
                      edit: tmp[1].edit,
                      show: tmp[1].show,
                      required: tmp[1].required,
                      type: tmp[1].type,
                      dictCode: tmp[1].dictCode,
                      sortNo: tmp[1].sortNo,
                      colspan: tmp[1].colspan
                    }
                    if (tmp[1].group === 'img') {
                      tmpImgList.push(tmpData)
                    } else {
                      tmpList.push(tmpData)
                    }
                  }
                }
                tmpImgList = tmpImgList.sort((a, b) => a.sortNo - b.sortNo)
                tmpList = tmpList.sort((a, b) => a.sortNo - b.sortNo)
              }
              item.fieldData = tmpList
              item.imgData = tmpImgList
            })
          }
          that.common.setStorage('itemsOptions', itemList)

          // 倒计时
          that.timeCountdown()
        } else {
          that.errFlag = true
        }
      })
    },
    // 查询项目基础信息
    getProjectDetail () {
      const that = this
      if (!that.projectId) {
        return
      }
      const url = '/biz/infocollect/getProjectDetail?pid=' + that.projectId
      that.axios.get(url).then((res) => {
        if (res.success) {
          that.errFlag = false
          const resData = res.result
          that.model = resData
          // 阅读须知阅读状态
          if (resData.readFlag === 1) {
            that.readFlag = true
          } else {
            that.readFlag = false
          }
          // 判断是否展示阅读须知
          if (resData.noticeVisible) {
            that.showNotice = true
            that.noticeTime = resData.readSecond
          } else {
            that.showNotice = false
            that.noticeTime = 0
          }
          // 项目限时有效
          if (resData.isExpired === 0) {
            that.expireFlag = true
            // 判断当前日期
            let curDate = new Date()
            if (curDate > Date.parse(resData.beginTime) && curDate < Date.parse(resData.endTime)) {
              that.editFlag = true
            } else {
              that.noticeTime = 0
              that.editFlag = false
            }
          } else {
            that.expireFlag = false
            that.editFlag = true
          }
          // 用户已经阅读过阅读须知
          if (that.readFlag) {
            that.noticeTime = 0
          }
          // 倒计时
          that.timeCountdown()
        } else {
          that.errFlag = true
        }
      })
    },
    // 倒计时
    timeCountdown () {
      if (!this.noticeTime) {
        this.tipVisible = false
        return
      }
      this.tipVisible = true
      let timer = setInterval(() => {
        if (this.noticeTime > 0) {
          this.noticeTime--
        } else {
          clearInterval(timer)
          this.updateReadStatus()
          this.tipVisible = false
        }
      }, 1000)
    },

    // 更新学生阅读须知阅读状态
    updateReadStatus() {
      if (!this.readFlag) {
        const url = '/biz/infocollect/updateReadState?pid=' + this.projectId
        this.axios.get(url).then((res) => {
          if (res.success) {
            this.userInfo.readFlag = 1
            this.common.setStorage('userInfo', this.userInfo)
          }
        })
      }
    },

    // 跳转预览页面
    goPreInfo () {
      let path = `/personalcenters/infocollect/previewInfo?pid=${this.projectId}`
      if (this.pgType) {
        path = path + `&pt=${this.pgType}`
      }
      if (this.bid) {
        path = path + `&bid=${this.bid}`
      }
      this.$router.push({path: path})
    },

    // 跳转填报页面
    goFillInfo () {
      let path = `/personalcenters/infocollect/fillInfo?pid=${this.projectId}`
      if (this.pgType) {
        path = path + `&pt=${this.pgType}`
      }
      if (this.bid) {
        path = path + `&bid=${this.bid}`
      }
      if (this.pgType === 'todo') {
        this.$router.push({path: path})
      } else {
        this.axios.get('/biz/infocollect/fillCheck').then(res => {
          if (res.success) {
            this.$router.push({path: path})
          } else {
            this.$message.warning(res.message)
            return false
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.page-div {
  width: 100%;
  background: #eaeaea;
  /*max-height: 910px;*/
  height: 100%;
  max-height: 100%;
  overflow-y: auto;
}
.main-div {
  max-width: 1200px;
  padding: 12px 0;
  height: 720px;
  margin: 0 auto;
}

.content-div {
  margin: 1px auto;
  padding: 24px;
  background: #fff;
  opacity: 1;
  height: 100%;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08)
}

.con-title {
  margin: 12px 24px;
  text-align: center;
  opacity: 1;
  font-size: 28px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 40.54px;
  color: rgba(48, 49, 51, 1);
}

.con-artc {
  border: 1px solid #f1f1f1;
  padding: 12px;
  height: 480px;
  overflow-y: auto;
  opacity: 1;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 22px;
  color: rgba(96, 98, 102, 1);
  text-align: left;
  vertical-align: top;
  /* 设置图片样式，使其最大不超过 div 容器 */
  img {
    max-width: 100%;
    max-height: 100%;
    display: block;
    margin: auto;
  }
}

.con-button {
  padding: 12px 0;
  text-align: center;
}

.con-button button {
  width: 130px;
  height: 35px;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/infocollect/CollectNoticeIndex.vue